import { KeyValue } from "../../../../../../../helpers/types/common";

import * as yup from "yup";
import { UploadNewDocumentFormKey } from "./Models";

export const UploadNewDocumentModalValidationSchema = (
  commonValidationMessages: KeyValue,
) =>
  yup.object().shape({
    [UploadNewDocumentFormKey.documentType]: yup
      .string()
      .required(commonValidationMessages.requiredValidation),
    [UploadNewDocumentFormKey.uploadedDate]: yup.string(),
    [UploadNewDocumentFormKey.file]: yup
      .mixed()
      .required(commonValidationMessages.requiredValidation),
    [UploadNewDocumentFormKey.description]: yup.string(),
  });
